<template>
  <v-application v-if="access.inv_inventory_counts">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="inventory count"
          v-bind:headers="headers"
          to="/inventory/counts"
          v-bind:data="inventory_counts"
          no-delete
          view
          v-bind:num-pages="inventory_counts_total"
          v-model="inventory_counts_page"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          v-bind:add_button_name="'add_inventory_count'"
          showSearch
          InventoryCount
          v-bind:search_text="search_text"
          v-bind:getData="update_inventory_counts"
          v-bind:searchActivate="
            (state) => {
              search_text = state;
            }
          "
          v-bind:setText="
            (text) => {
              search = text;
            }
          "
        >
          <template #top>
            <v-btn
              v-if="store && store._id !== ''"
              text
              @click="itemImportExcel"
              >{{ $t("import") }}</v-btn
            >
            <!-- <v-btn
              v-if="store && store._id !== ''"
              text
              @click="itemImportByBarcodeExcel"
              >{{ $t("import_by_barcode") }}</v-btn
            > -->
            <v-btn
              v-if="store && store._id !== ''"
              text
              @click="Downloadexcel"
              >{{ $t("export") }}</v-btn
            >
            <v-combobox
              v-model="status"
              label="Status"
              v-bind:items="statusses"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              v-model="store"
              label="Store"
              v-bind:items="stores"
              hide-details
              item-text="name"
              class="mx-1"
            />
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog_import_item" width="500">
      <v-card>
        <v-card-title>{{ $t("import") }}</v-card-title>
        <v-card-text>
          <a href="http://purch.invan.uz/static/customers.xlsx"
            >Download template file</a
          >
          and fill in with the customers information.
        </v-card-text>
        <v-card-text>
          <v-file-input
            v-model="file"
            accept=".xlsx"
            label="Select File..."
            show-size
            filled
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text v-on:click="dialog_import_item = false">{{
            $t(`cancel`)
          }}</v-btn>
          <v-btn
            text
            color="primary"
            v-on:click="uploading"
            :loading="buttunloader"
            >{{ $t(`upload`) }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_import_by_barcode_item" width="500">
      <v-card>
        <v-card-title>{{ $t("import") }}</v-card-title>
        <v-card-text>
          <a href="http://purch.invan.uz/static/customers.xlsx"
            >Download template file</a
          >
          and fill in with the customers information.
        </v-card-text>
        <v-card-text>
          <v-file-input
            v-model="file"
            accept=".xlsx"
            label="Select File..."
            show-size
            filled
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text v-on:click="dialog_import_by_barcode_item = false">{{
            $t(`cancel`)
          }}</v-btn>
          <v-btn
            text
            color="primary"
            v-on:click="uploadingByBarcode"
            :loading="buttunloaderBarcode"
            >{{ $t(`upload`) }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exceldialog" max-width="500px">
      <v-card>
        <v-card-title v-if="excelwait">Iltimos, kutib turing!</v-card-title>
        <v-card-title v-else>Excel yuklashga tayyor!</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text color="primary" @click="saveExcel" :disabled="excelwait">
            <export-excel :data="downExcel" :name="excel_name"
              >Save Excel</export-excel
            >
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import InventoryCounts from "../../mixins/inventory/inventory_count";
import Userable from "../../mixins/userable";
export default {
  name: "Stock",
  mixins: [Services, InventoryCounts, Userable],
  data: () => ({
    headers: [
      { text: "Inventory count", value: "p_order" },
      { text: "Date created", value: "created_time" },
      { text: "Date completed", value: "created_time" },
      { text: "Store", value: "service_name" },
      { text: "Status", value: "status" },
      { text: "Notes", value: "notes" },
    ],
    data: [],
    search_text: false,
    search: "",
    dialog_import_item: false,
    dialog_import_by_barcode_item: false,
    file: null,
    downExcel: [],
    excel_name: "ExcelItems",
    exceldialog: false,
    excelwait: true,
    buttunloader: false,
    buttunloaderBarcode: false,
  }),
  methods: {
    itemImportExcel() {
      this.dialog_import_item = true;
    },
    itemImportByBarcodeExcel() {
      this.dialog_import_by_barcode_item = true;
    },
    async uploading() {
      this.buttunloader = true;
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `/inventory/${org_id}/${service_id}`;
      await this.$communicator.file1(link, { file: this.file });
      this.dialog_import_item = false;
    },
    async uploadingByBarcode() {
      this.buttunloaderBarcode = true;
      const service_id = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `/inventory/by_barcode/${org_id}/${service_id}`;
      await this.$communicator.file1(link, { file: this.file });
      this.dialog_import_by_barcode_item = false;
    },
    async Downloadexcel() {
      this.exceldialog = true;
      this.loading = true;
      const service = this.store ? this.store._id : "";
      const org_id = this.user ? this.user.organization : "";
      const link = `/iventory/items/${org_id}/${service}`;
      let body = {
        limit: "all",
        page: 1,
      };
      const items = await this.$communicator.postMethod2(link, body);
      const result = await items?.data?.data.map((itm) => ({
        _id: itm._id,
        sku: itm.sku,
        name: itm.name,
        barcode: itm.barcode,
        in_stock: itm.in_stock?.toFixed(2),
      }));
      this.downExcel = await result;
      setTimeout(() => (this.excelwait = false), 3000);
    },
    saveExcel() {
      this.exceldialog = false;
      this.excelwait = true;
    },
    changePagination(page) {
      this.inventory_counts_page = page;
      this.update_inventory_counts();
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("inventory_count"), value: "p_order", available: true },
      { text: this.$t("date_created"), value: "created_time", available: true },
      {
        text: this.$t("date_completed"),
        value: "created_time",
        available: true,
      },
      { text: this.$t("store"), value: "service_name", available: true },
      { text: this.$t("status"), value: "status", available: true },
      { text: this.$t("notes"), value: "notes", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  watch: {
    store: {
      deep: true,
      handler() {
        this.update_inventory_counts();
      },
    },
    status: {
      deep: true,
      handler() {
        this.update_inventory_counts();
      },
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
